import type { IconData } from '@stacksjs/iconify-core'

export const smileysNeutral: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5 6a1 1 0 1 0 0-2a1 1 0 0 0 0 2m6 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-1 4V8H6v2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default smileysNeutral
